// Thin shell — re-exports the WithdrawModal component after a mechanical
// file-size split. See WithdrawModal.component.tsx for the component/render,
// useWithdrawModal.tsx for the extracted logic hook, WithdrawModal.helpers.ts
// for pure helpers, and WithdrawModal.types.ts for the prop types.
import WithdrawModal from "./WithdrawModal.component";

export default WithdrawModal;
